// Types
import { Column } from '../objects/column';
import { Picture } from '../../picture/objects/picture';
import { Preferences } from '../../profile/objects/preferences';
import { RecommendedAccommodationState } from '../objects/recommendedAccommodationState';
// Action Types
import {
    ADD_PREFERENCES,
    DELETE_CUSTOM_PICTURE,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RecommendedAccommodationActionTypes,
    RESET_FILTERS,
    RESET_RECOMMENDED_ACCOMMODATION,
    SET_EDIT,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_LIST_ITEM_BLACKLIST,
    SET_LIST_ITEM_FAVORITE,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_RECOMMENDED_ACCOMMODATION_PREFERENCES,
    SET_RECOMMENDED_ACCOMMODATION,
    SET_RECOMMENDED_ACCOMMODATION_SELECTED,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN,
    TOGGLE_PICTURE_ACTIVATED,
    TOGGLE_REFRESH,
    UPDATE_FILTER_CITY,
    UPDATE_FILTER_COUNTRY,
    UPDATE_FILTER_IS_ALL_ACCOMMODATION,
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_TAG,
    UPDATE_LIST_ITEM_BLACKLIST,
    UPDATE_LIST_ITEM_FAVORITE,
    UPDATE_PICTURE_ORDER,
    UPDATE_REMARK_FAVORITE,
    SET_COLUMNS,
    SET_ACCOMMODATION_TAGS
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { ADD_CUSTOM_PICTURES, PictureActionTypes, SET_PICTURE } from '../../picture/redux/actionTypes';
import { RecommendedAccommodationReduced } from '../objects/recommendedAccommodationReduced';
import { AccommodationTag } from '../../accommodationTag/objects/accommodationTag';

const initialState: RecommendedAccommodationState = {
    columns: [{
        label: 'accommodation-name',
        field_name: 'ACCOMMODATION_NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'address',
        field_name: 'ADDRESS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'city',
        field_name: 'CITY',
        checked: true,
        order_by: 'city_name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'country-code',
        field_name: 'COUNTRY_CODE',
        checked: true,
        order_by: 'country_code',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'custom-picture(s)',
        field_name: 'CUSTOM_PICTURES',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'referential-picture(s)',
        field_name: 'REFERENTIAL_PICTURES',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'recommended',
        field_name: 'RECOMMENDED',
        checked: true,
        order_by: 'favorite',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'blacklisted',
        field_name: 'BLACKLISTED',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'tags',
        field_name: 'Tags',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }],
    count: 0,
    custom_pictures: [],
    custom_pictures_order: [],
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_city: '',
    filter_country: null,
    filter_name: '',
    filter_tags: [],
    filter_open: false,
    giata_pictures: [],
    is_all_accommodation: 'all',
    limit: 25,
    list: null,
    list_confirm_action_is_open: false,
    order: 'asc',
    order_by: '-created_date',
    page: 0,
    preferences: [],
    recommended_accommodation: null,
    recommended_accommodation_selected: [],
    remark_favorite: '',
    refresh: false,
    running: false,
    search: '',
    accommodation_tags: []
};

export default (state: RecommendedAccommodationState = initialState, action: RecommendedAccommodationActionTypes | ProfileActionTypes | PictureActionTypes): RecommendedAccommodationState => {
    switch (action.type) {
        case ADD_PREFERENCES: {
            return {...state, preferences: [...state.preferences, ...action.payload]};
        }
        case ADD_CUSTOM_PICTURES: {
            return {...state, custom_pictures: [...state.custom_pictures, ...action.payload]};
        }
        case DELETE_CUSTOM_PICTURE: {
            let custom_pictures = [...state.custom_pictures];
            custom_pictures.splice(action.payload, 1);
            return {...state, custom_pictures: custom_pictures};
        }
        case MOVE_DOWN_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_city: '',
                filter_country: null,
                filter_name: '',
                filter_tags: [],
            };
        }
        case RESET_RECOMMENDED_ACCOMMODATION: {
            return {...state};
        }
        case SET_EDIT: {
            if (state.recommended_accommodation !== null) {
                let custom_pictures: Picture[] = [];
                let giata_pictures: (Picture & {activated: boolean})[] = [];
                if (state.recommended_accommodation.custom_pictures !== null && state.recommended_accommodation.custom_pictures.length > 0) {
                    state.recommended_accommodation.custom_pictures.map(custom_picture => {
                        let activated = false;
                        if (state.recommended_accommodation?.pictures !== null) {
                            state.recommended_accommodation?.pictures.map(picture => {
                                if (custom_picture.id === picture.id) {
                                    activated = true;
                                }
                            });
                        }
                        if (!activated) {
                            custom_pictures.push({...custom_picture});
                        }
                    });
                }
                if (state.recommended_accommodation.pictures !== null) {
                    state.recommended_accommodation.pictures.map(picture => {
                        let activated = state.recommended_accommodation?.custom_pictures === null || state.recommended_accommodation?.custom_pictures.length === 0;
                        if (state.recommended_accommodation?.custom_pictures !== null && (state.recommended_accommodation?.custom_pictures.length ?? 0) > 0) {
                            state.recommended_accommodation?.custom_pictures.map(custom_picture => {
                                if (custom_picture.id === picture.id) {
                                    activated = true;
                                }
                            });
                        }
                        giata_pictures.push({...picture, activated: state.recommended_accommodation?.ignore_giata_pictures ? false : activated});
                    });
                }
                return {
                    ...state,
                    edit: action.payload,
                    custom_pictures: custom_pictures,
                    custom_pictures_order: state.recommended_accommodation.custom_pictures !== null && state.recommended_accommodation.custom_pictures.length > 0 ? [...state.recommended_accommodation.custom_pictures] : state.recommended_accommodation.pictures !== null && state.recommended_accommodation.pictures.length > 0 ? [...state.recommended_accommodation.pictures] : [],
                    giata_pictures: giata_pictures,
                    remark_favorite: state.recommended_accommodation.remark_favorite !== null ? state.recommended_accommodation.remark_favorite : ''
                }
            }
            return state;
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: RecommendedAccommodationState = {...state};
            errors.map(error => {
                if (error.subkey !== undefined && error.subkey_index !== undefined) {
                    let property = [...new_state[error.key]];
                    let sub_property = {...property[error.subkey_index]};
                    sub_property[error.subkey] = error.error;
                    property[error.subkey_index] = sub_property;
                    new_state[error.key] = property;
                } else {
                    new_state[error.key] = error.error;
                }
            });
            return {...new_state};
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload};
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results as RecommendedAccommodationReduced[], recommended_accommodation_selected:[], running: false};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PICTURE: {
            if (action.payload !== true && action.payload !== false) {
                let custom_pictures = [...state.custom_pictures];
                for (let i = 0; i < custom_pictures.length; i++) {
                    if (custom_pictures[i].id === action.payload.id) {
                        custom_pictures[i] = {...action.payload};
                        break;
                    }
                }
                return {...state, custom_pictures: custom_pictures};
            }
            return state;
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            let new_columns: Column[] = [];
            let new_order_by = 'name';
            let new_order: 'asc' | 'desc' = 'asc';
            let field_name: string[] = [];
            let recommended_accommodation_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'RECOMMENDED_ACCOMMODATION') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'ACCOMMODATION_NAME':
                                new_columns.push({label: 'accommodation-name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'name' : new_order_by;
                                break;
                            case 'ADDRESS':
                                new_columns.push({label: 'address', field_name: preference.field_name, checked: preference.active, order_by: 'address', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'address' : new_order_by;
                                break;
                            case 'CITY':
                                new_columns.push({label: 'city', field_name: preference.field_name, checked: preference.active, order_by: 'city_name', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'city_name' : new_order_by;
                                break;
                            case 'COUNTRY_CODE':
                                new_columns.push({label: 'country-code', field_name: preference.field_name, checked: preference.active, order_by: 'country_code', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'country_code' : new_order_by;
                                break;
                            case 'CUSTOM_PICTURES':
                                new_columns.push({label: 'custom-picture(s)', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'REFERENTIAL_PICTURES':
                                new_columns.push({label: 'referential-picture(s)', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'RECOMMENDED':
                                new_columns.push({label: 'recommended', field_name: preference.field_name, checked: preference.active, order_by: 'favorite', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'favorite' : new_order_by;
                                break;
                            case 'BLACKLISTED':
                                new_columns.push({label: 'blacklisted', field_name: preference.field_name, checked: preference.active, order_by: 'blacklist', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'blacklist' : new_order_by;
                                break;
                            case 'TAGS':
                                new_columns.push({label: 'tags', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? '' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        recommended_accommodation_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: recommended_accommodation_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_RECOMMENDED_ACCOMMODATION_PREFERENCES: {
            return {...state, preferences: action.payload};
        }
        case SET_RECOMMENDED_ACCOMMODATION: {
            let tags: AccommodationTag[] = [];
            if(action.payload.tags.length > 0 && typeof action.payload.tags[0] !== 'object') {
                tags = (action.payload.tags as unknown as number[]).map((tag: number) => (state.accommodation_tags[tag]));
            } else {
                tags = action.payload.tags;
            }
            return {...state, recommended_accommodation: {...action.payload, tags}};
        }
        case SET_RECOMMENDED_ACCOMMODATION_SELECTED: {
            return {...state, recommended_accommodation_selected: action.payload};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, list: null, search: action.payload, page: 0};
        }
        case TOGGLE_COLUMN: {
            let columns = [...state.columns];
            let column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_LIST_COMFIRM_ACTION_IS_OPEN:{
            return {...state, list_confirm_action_is_open: action.payload };
        }
        case TOGGLE_PICTURE_ACTIVATED: {
            const giata_pictures = [...state.giata_pictures];
            const picture = {...giata_pictures[action.payload]};
            picture.activated = !picture.activated;
            giata_pictures[action.payload] = picture;
            return {...state, giata_pictures: giata_pictures};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_FILTER_CITY: {
            return {...state, filter_city: action.payload};
        }
        case UPDATE_FILTER_COUNTRY: {
            return {...state, filter_country: action.payload};
        }
        case UPDATE_FILTER_IS_ALL_ACCOMMODATION: {
            return {...state, is_all_accommodation:action.payload};
        }
        case UPDATE_FILTER_NAME: {
            return {...state, filter_name: action.payload};
        }
        case UPDATE_FILTER_TAG: {
            return {...state, filter_tags: action.payload};
        }
        case UPDATE_LIST_ITEM_BLACKLIST: {
            if (state.list !== null) {
                let list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload) {
                        list[i].blacklist = !list[i].blacklist;
                        if (list[i].blacklist) {
                            list[i].favorite = false;
                        }
                        break;
                    }
                }
                return {...state, list: list,  recommended_accommodation_selected:[]};
            }
            return state;
        }
        case UPDATE_LIST_ITEM_FAVORITE: {
            if (state.list !== null) {
                let list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload) {
                        list[i].favorite = !list[i].favorite;
                        if (list[i].favorite) {
                            list[i].blacklist = false;
                        }
                        break;
                    }
                }
                return {...state, list: list,  recommended_accommodation_selected:[]};
            }
            return state;
        }
        case SET_LIST_ITEM_FAVORITE: {
            if (state.list !== null) {
                let list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload.index) {
                        list[i].favorite = action.payload.action;
                        if (action.payload.action) {
                            list[i].blacklist = false;
                        }
                        break;
                    }
                }
                return {...state, list: list,  recommended_accommodation_selected:[]};
            }
            return state;
        }
        case SET_LIST_ITEM_BLACKLIST: {
            if (state.list !== null) {
                let list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload.index) {
                        list[i].blacklist = action.payload.action;
                        if (action.payload.action) {
                            list[i].favorite = false;
                        }
                        break;
                    }
                }
                return {...state, list: list,  recommended_accommodation_selected:[]};
            }
            return state;
        }
        case UPDATE_PICTURE_ORDER: {
            const { drag_index, hover_index } = action.payload;
            let custom_pictures_order = [...state.custom_pictures_order];
            custom_pictures_order.splice(drag_index, 1);
            custom_pictures_order.splice(hover_index, 0, state.custom_pictures_order[drag_index]);
            return {...state, custom_pictures_order: custom_pictures_order};
        }
        case UPDATE_REMARK_FAVORITE: {
            return {...state, remark_favorite: action.payload};
        }
        case SET_COLUMNS: {
            return {...state, columns: action.payload};
        }
        case SET_ACCOMMODATION_TAGS: {
            return {...state, accommodation_tags: action.payload};
        }
        default:
            return state;
    }
};